// extracted by mini-css-extract-plugin
module.exports = {"link":"JwBr6f","media":"_22uytq","body":"_2ABbP9"};